import axios from 'axios';
import { config_headers, URL_API,servicelist } from '../Config';

export const P230GetDataList= async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers);
            await axios.post(URL_API(`${servicelist.P1Service}p_p1_list`), body, authorization )
                .then(res => {
                    resolve(res.data);
                }).catch((error)=> {
                    reject(error);
                });
        }
        catch (err) {
            reject(err);
        }
        finally {

        }
    })
}
